import type { TourDefinition } from "../types";
import { welcomeTour } from "./welcome";
import { productLibraryTour } from "./productLibrary";
import { productEditorTour } from "./productEditor";
import { editVisualTour } from "./editVisual";
import { assetLibraryTour } from "./assetLibrary";
import { workspaceSettingsTour } from "./workspaceSettings";

/**
 * Registry of all available tours.
 *
 * IMPORTANT: order matters for `findTourForRoute` — more specific routes must
 * come before less specific ones. Anything nested under /app/products/:id must
 * appear before the broader /app/products/:id product editor match.
 */
export const allTours: TourDefinition[] = [
  // Specific page tours first — the welcome tour's routeMatch is /^\/app/ so
  // it would otherwise swallow every page. `findTourForRoute` returns the
  // FIRST match, so ordering is load-bearing.
  productEditorTour,
  productLibraryTour,
  editVisualTour,
  assetLibraryTour,
  workspaceSettingsTour,
  welcomeTour,
];

/** Look up a tour by its stable id. */
export function findTourById(id: string): TourDefinition | undefined {
  return allTours.find((t) => t.id === id);
}

/** Find the tour that owns the given pathname, if any. First match wins. */
export function findTourForRoute(pathname: string): TourDefinition | null {
  return allTours.find((t) => t.routeMatch.test(pathname)) ?? null;
}

/** All tours whose routeMatch hits this pathname, in registration order. */
export function findAllToursForRoute(pathname: string): TourDefinition[] {
  return allTours.filter((t) => t.routeMatch.test(pathname));
}
